export const LIST_ITEM_OPTION = 'list_item_option'
export const OPTION_EXISTING_LIST_ITEM = 'option_existing_list_item'
export const OPTION_NEW_LIST_ITEM = 'option_new_list_item'
